module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_troendelag_neg.03a15d65.pdf";